import { ChatSession } from './researchChat';
export interface SavedChat { token:string; title:string; updated:number; draft:string }
const KEY='research-chat-history-v1';
export function readChats(): SavedChat[] {
  try { return (JSON.parse(localStorage.getItem(KEY) || '[]') as SavedChat[]).filter(c=>typeof c.token==='string' && typeof c.title==='string' && Date.now()-c.updated < 7*86400000).slice(0,20); } catch { return []; }
}
export function storeChat(token:string, session:ChatSession|null, draft:string) {
  const old=readChats(); const entry=old.find(c=>c.token===token);
  const chats=[{token,title:session?.title || entry?.title || 'New conversation',updated:Date.now(),draft},...old.filter(c=>c.token!==token)].slice(0,20);
  try {localStorage.setItem(KEY,JSON.stringify(chats));} catch { /* Chat stays usable when browser storage is full. */ }
  return chats;
}
